import { useStaticQuery, graphql } from "gatsby";

const NGOJson = () => {
  const data = useStaticQuery(graphql`
    query {
      allMysqlEin {
        edges {
          node {
            ein
            name
            crtorev
            city
            state            
          }
        }
      }
    }
  `);

  return data.allMysqlEin.edges
    .filter((item) => item.node.ein !== null)
    .map((item) => ({
      imageURL: (item.node.imageURL !== null && item.node.imageURL !== "") ? item.node.imageURL : null,
      name: item.node.name,
      address: (item.node.city && item.node.state) ? `${item.node.city}, ${item.node.state}` : "",
      ein: item.node.ein,
      crtorev: item.node.crtorev,
      ntee_code: item.node.ntee_code
    }));
};

export default NGOJson;
